import { forwardRef, memo, type ElementType, type Component } from 'react';
import clsx from 'clsx';
import { FormattedMessage } from 'react-intl';
// Material UI imports
import { type SystemProps } from '@mui/system/Box';
import Box, { type BoxProps } from '@mui/material/Box';
// local imports
import { Values } from '../helpers/intl';
// SCSS imports
import { subheader } from './CardSubheader.module.scss';

type CardSubheaderProps = SystemProps & {
  readonly component?: ElementType;
  readonly className?: string;
  readonly text: string;
  readonly values?: Values;
};

const CardSubheader = forwardRef<Component<BoxProps>, CardSubheaderProps>(({
  component: UIComponent = Box,
  text,
  values,
  className,
  ...props
}, ref) => (
  <UIComponent
      ref={ref}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      className={clsx(subheader, className)}
  >
    <FormattedMessage id={text} values={values} defaultMessage={text}/>
  </UIComponent>
));

CardSubheader.displayName = 'CardSubheader';

export default memo(CardSubheader);
